export const ACTION = '/StoreLocator/SearchStores';
